export enum AnimationClass {
  SoundOn="isSoundOn",
  SoundOff="isSoundOff",
  Liked="isLiked",
  Unlike="isUnLiked"
}

type ApplyAnimationArgs = {
  animationClass: string;
  ref: React.RefObject<HTMLDivElement | null>;
}

const DELAY = 100;

export const applyAnimation = ({ animationClass, ref }: ApplyAnimationArgs) => {
  if (ref.current) {
    ref.current.classList.remove(...Object.values(AnimationClass));

    setTimeout(() => {
      ref.current?.classList.add(animationClass);
    }, DELAY);
  }
};
